<template>
  <div class="entry">
    <header class="df both-side">
      <div>天眼</div>
      <div @click="logout">退出</div>
    </header>
    <div
      class="entry-item df vertical both-side"
      v-for="(item, index) in localMenu"
      :key="index"
      @click="toMobilePath(item)"
    >
      <div class="df vertical">
        <!-- <img
          :src="require(`../../assets/img/mobile/page/${item.name}.png`)"
          class="menu-icon"
        /> -->
        <div class="text">
          {{ item.meta.title }}
        </div>
      </div>
      <img src="@/assets/img/mobile/page/entry-enter.png" class="entry-icon" />
    </div>
    <div class="entry-item df vertical both-side" @click="toChangePassword" v-if="user.id !== 119">
      <div class="df vertical">
        <img src="@/assets/img/mobile/page/menu.png" class="menu-icon" />
        <div class="text">修改密码</div>
      </div>
      <img src="@/assets/img/mobile/page/entry-enter.png" class="entry-icon" />
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, reactive } from "vue";
import { useStore } from "vuex";
import { getPermissionsByUserId } from "@/request/view/permissions";
import { useRouter } from "vue-router";
import Cookie from "js-cookie";

export default defineComponent({
  setup() {
    const store = useStore();
    const router = useRouter();
    const user = store.state.user.user;
    const toMobilePath = (menuItem) => {
      router.push({ path: menuItem.path });
    };

    const localMenu = reactive([
      {
        id: 319,
        name: "aftersalerepair",
        meta: {
          title: "日常报修",
        },
        path: "/mobileaftersalerepair",
      },
      {
        id: 328,
        name: "mobileaftersalesmanagement",
        meta: {
          title: "样机管理",
        },
        path: "/mobileaftersalesmanagement",
      },
      {
        id: 368,
        name: "brandcatalog",
        meta: {
          title: "产品目录",
        },
        path: "/brandcatalog",
      },
      // {
      //   id: 278,
      //   name: "aftersalerepair",
      //   meta: {
      //     title: "设备返修",
      //   },
      //   path: "/repair",
      // },
      // {
      //   id: 294,
      //   name: "inspection",
      //   meta: {
      //     title: "日常质检",
      //   },
      //   path: "/mobileinspection",
      // },
      // {
      //   id: 296,
      //   name: "product",
      //   meta: {
      //     title: "日常生产",
      //   },
      //   path: "/mobileproduct",
      // },
      // {
      //   id: 316,
      //   name: "materialwarehouse",
      //   meta: {
      //     title: "仓库",
      //   },
      //   path: "/mobilematerialwarehouse",
      // },
    ]);

    const menu = computed(() => {
      return store.getters.menu;
    });

    const logout = () => {
      localStorage.setItem("logout", "true");
      store.commit("SET_USER_INFO", {});
      const long = window.history.length - 1;
      router.go(-long);
      window.location.reload();
    };

    const toChangePassword = () => {
      router.push({ path: "/mobilechangepassword" });
    };

    getPermissionsByUserId({
      userId: store.state.user.user.id,
    }).then((res) => {
      if (res.code === 200) {
        const authorityMenu = localMenu.filter(
          (m) => res.data.findIndex((id) => m.id === id) !== -1
        );
        localMenu.length = 0;
        localMenu.push(...authorityMenu);
      }
    });

    return {
      menu,
      user,
      localMenu,
      logout,
      toMobilePath,
      toChangePassword,
    };
  },
});
</script>

<style lang="less" scoped>
header {
  height: 2.16rem;
  padding: 0.8rem 0.6rem 0.72rem 0.4rem;

  img {
    width: 1.03rem;
    height: 1.19rem;
    margin-right: 0.44rem;
  }

  div {
    font-size: 0.64rem;
    font-weight: bold;
    color: #ffffff;
    line-height: 0.96rem;
    text-shadow: 0px 0px 0px rgba(0, 0, 0, 0.5);
  }
}

.entry {
  background: #c2f0fe;
  width: 100vw;
  height: 100vh;
  overflow: scroll;
  background-image: url("../../assets/img/mobile/page/header-background.png");
  background-repeat: no-repeat;
  background-size: 10rem 5.25rem;
  background-position: top;

  .entry-item {
    margin: 0 auto;
    width: 9.2rem;
    height: 2.93rem;
    background: linear-gradient(180deg, #ecfafc 0%, #ffffff 100%);
    box-shadow: 0rem 0.21rem 0.32rem 0.03rem rgba(8, 26, 81, 0.04),
      0rem 0.11rem 0.13rem -0.07rem rgba(8, 26, 81, 0.05);
    border-radius: 0.4rem;
    padding: 0 0.72rem;
    margin-bottom: 0.53rem;

    .menu-icon {
      width: 0.71rem;
      height: 0.71rem;
      margin-right: 0.21rem;
    }

    .text {
      font-size: 0.64rem;
      color: #143022;
      line-height: 2.93rem;
      font-weight: bold;
    }

    .entry-icon {
      width: 0.64rem;
      height: 0.64rem;
    }
  }
}
</style>
